import { CHART_COLOR_PALETTE } from "src/components/charts/ChartPalette";

/** Backend segment order (pie + legend stay consistent if API order varies). */
export const CLTV_SEGMENT_PIE_ORDER = [
  "Loyal",
  "High Spender",
  "Cart Abandoner",
  "One Timer",
  "Indecisive",
  "Idle",
  "Likely to Churn",
] as const;

/** Pie colors by segment name (aligned with previous static palette). */
export const CLTV_SEGMENT_COLORS: Record<string, string> = {
  Loyal: CHART_COLOR_PALETTE[0],
  "High Spender": CHART_COLOR_PALETTE[1],
  "Likely to Churn": CHART_COLOR_PALETTE[2],
  "One Timer": CHART_COLOR_PALETTE[3],
  "Cart Abandoner": CHART_COLOR_PALETTE[4],
  Indecisive: CHART_COLOR_PALETTE[5],
  Idle: CHART_COLOR_PALETTE[6],
};

export const defaultCltvSegmentColor = CHART_COLOR_PALETTE[7];
